import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import MyDomaineApp from "./MyDomaineApp";
import { HouseType } from "./types";

function INIT_PYHT_APP() {
  let isKioskMode = false;
  let hasKioskMenu = false;
  let baseUrl = "price-your-home";
  let settings = {};
  let regions = [];
  let nswRegions = [];
  let consultants = [];
  let exteriorStyles = [];
  let interiorStyles = [];
  let home = undefined;
  let flipped = undefined;
  let floorplanOptions = undefined;
  let user = undefined;
  let uuid = undefined;
  let sessionState = undefined;
  let houseType = undefined;
  const appRoot = document.getElementById("pyht-app-root");
  if (appRoot) {
    isKioskMode = appRoot.getAttribute("data-kiosk-mode") === "1";
    hasKioskMenu = appRoot.getAttribute("data-kiosk-menu") === "1";
    const urlPayload = appRoot.getAttribute("data-url");
    const homePayload = appRoot.getAttribute("data-home");
    const flippedPayload = appRoot.getAttribute("data-flipped");
    const userPayload = appRoot.getAttribute("data-user");
    const floorplanOptionsPayload = appRoot.getAttribute(
      "data-floorplan-options"
    );
    const sessionStatePayload = appRoot.getAttribute("data-session-state");
    const uuidPayload = appRoot.getAttribute("data-uuid");
    const houseTypePayload = appRoot.getAttribute("data-house-type");
    if (urlPayload) {
      baseUrl = urlPayload as string;
    }
    if (houseTypePayload) {
      houseType = houseTypePayload as HouseType;
    }

    const settingsPayload = appRoot.getAttribute("data-settings");
    if (settingsPayload) {
      settings = JSON.parse(settingsPayload);
    }

    const regionsPayload = appRoot.getAttribute("data-regions");
    if (regionsPayload) {
      regions = JSON.parse(regionsPayload);
    }

    const nswRegionsPayload = appRoot.getAttribute("data-nsw-regions");
    if (nswRegionsPayload) {
      nswRegions = JSON.parse(nswRegionsPayload);
    }

    const consultantsPayload = appRoot.getAttribute("data-consultants");
    if (consultantsPayload) {
      consultants = JSON.parse(consultantsPayload);
    }

    const exteriorStylesPayload = appRoot.getAttribute("data-exterior-styles");
    if (exteriorStylesPayload) {
      exteriorStyles = JSON.parse(exteriorStylesPayload);
    }

    const interiorStylesPayload = appRoot.getAttribute("data-interior-styles");
    if (interiorStylesPayload) {
      interiorStyles = JSON.parse(interiorStylesPayload);
    }

    if (homePayload) {
      home = JSON.parse(homePayload);
    }

    if (userPayload) {
      user = JSON.parse(userPayload);
    }

    flipped = flippedPayload === "1";

    if (floorplanOptionsPayload) {
      floorplanOptions = JSON.parse(floorplanOptionsPayload);
    }

    if (uuidPayload) {
      uuid = uuidPayload;
    }

    if (sessionStatePayload) {
      sessionState = JSON.parse(sessionStatePayload);
    }
    if (
      appRoot.getAttribute("data-my-domaine-mode") == "1" ||
      appRoot.getAttribute("data-share-mode") == "1"
    ) {
      ReactDOM.render(
        <MyDomaineApp
          settings={settings}
          regions={regions}
          nswRegions={nswRegions}
          consultants={consultants}
          exteriorStyles={exteriorStyles}
          interiorStyles={interiorStyles}
          home={home}
          user={user}
          uuid={uuid}
          sessionState={sessionState}
          myDomainMode={appRoot.getAttribute("data-my-domaine-mode") == "1"}
          shareMode={appRoot.getAttribute("data-share-mode") == "1"}
        />,
        appRoot
      );
    } else {
      ReactDOM.render(
        <BrowserRouter basename={`${baseUrl}`}>
          <App
            settings={settings}
            regions={regions}
            nswRegions={nswRegions}
            consultants={consultants}
            exteriorStyles={exteriorStyles}
            interiorStyles={interiorStyles}
            home={home}
            houseType={houseType}
            isFlipped={flipped}
            floorplanOptions={floorplanOptions}
            isKioskMode={isKioskMode}
            hasKioskMenu={hasKioskMenu}
            user={user}
            uuid={uuid}
            sessionState={sessionState}
          />
        </BrowserRouter>,
        appRoot
      );
    }
  }
}

// @ts-ignore
window["INIT_PYHT_APP"] = INIT_PYHT_APP;

INIT_PYHT_APP();
